<script>
import CreatePaymentModal from './create_payment'
import { notify } from '@/helpers/notify' 
import {  mapGetters } from "vuex";
import PayLink from './paylink_modal'
import PrintMainVue from './PrintMain.vue';
import Vue from 'vue';

import { 
    requiredIf
} from "vuelidate/lib/validators";

export default {
    name: 'RenewalModal',
    props:[
        "data",
        "subsBalance",
        "modelOpen"
    ],
    components: {
        CreatePaymentModal,
        PayLink,
        PrintMainVue
    },
    data() {
        return {
            paymentModelOpen:false,
            installments:[],
            secili: [],
            installment_price:0,
            tariffList:[],
            stockList:[],
            loading: false,
            basket:[],
            form: {
                new_tariff_id: null,
                _installment: false
            },
            payAfterInfo:{
                expiredate:'',
                balance:0
            },
            odeme: {
                price: 0,
                amount:""
            },
            odemeyap:false,
            paymnet_type:0,
            paymnet_channel:"",
            submitted: false,
            banks:[],
            odenen_taksitler: [],
            paylinkData:{},
            paylinkModalOpen:0,
            printModelOpen:0,
            checkId: [],
            subsId:0
        };
    }, 
    validations: {
        paymnet_channel: {
            required: requiredIf(function () {
                return this.isAdmin
            })
        },
        odeme: {
            amount: {
                required: requiredIf(function () {
                    return this.paymnet_channel > 0 && this.paymnet_channel < 5 
                })
            }
        },
    },
   
    computed:{
        ...mapGetters('authfack', ['userdata']),
        modalTitle(){ return "Üyelik Yenile"},
        remainingDays(){
            const targetDate = new Date(this.form.expiredate);
            const currentDate = new Date();
            const timeDifference = targetDate - currentDate;
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            return daysDifference;
        },  
        remainingDayPay(){
            const  price   = this.form.price
            const  remainingDays = this.remainingDays 
            
            if(remainingDays >= 0) return 0
            return Math.abs(remainingDays * (price / 30 ));
        },
        isAdmin(){
            const userdata = this.userdata.currentUser
            return userdata.role_name == 'admin' || userdata.role_name == 'personel' || userdata.role_name == 'callcenter'  
        },

       
    },
    watch:{
        modelOpen(){
          
            this.form= { new_tariff_id: null,  _installment: false }
            this.odeme= { price: 0,  amount:"" }
            this.installments=[]
            this.secili= []
            this.installment_price= 0
            this.tariffList=[]
            this.loading= false
            this.odemeyap= false
            this.paymnet_type= 0,
            this.paymnet_channel= ""
            this.submitted= false
            this.banks= []
            this.odenen_taksitler=  []
           
            this.form = Object.assign({...this.data}, {new_tariff_id: this.data.tariff_name})

            this.odeme.price = this.form.price
            this.getTariffList()
            //this.getStock() 
            if(this.data.tariff?.installments){
                this.installments = this.data.tariff.installments
                this.installment_price = this.data.tariff.installment_price
            }
        },
        secili(val){
            this.odenen_taksitler = val.map(e=> e.num)
            this.odeme.amount = val.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a.price), 0);
        },
    },

    methods: {
       async getTariffList(){
            await this.$http.post('/tariff?output=one&fields=id,name,price,installment_price&where=type:' + this.form.tariff_type)
            .then(resp => {
                this.tariffList = resp.data.filter( e => e.id != this.form.tariff_id )
                const yeniObj = {id:null, name: 'Tarife Değiştir', price:0};
                this.tariffList.unshift(yeniObj) 
            })  
        },
        async getStock(){
            await this.$http.post('/stock?output=one&fields=id,name')
            .then(resp => {
                this.stockList = resp.data
            })
            
        },
        close(){
            this.$parent.$bvModal.hide('renewal_modal')
        },
        handleSubmit(){
            this.submitted = true;
            if(typeof this.form.new_tariff_id == 'string' && this.form.tariff_active == 0){
                notify.error("Eski tarifesi pasif olduğundan, yeni tarife seçerek devam ediniz.")
                this.submitted = false;
                return false;
            }

            this.$v.paymnet_channel.$touch();
            this.$v.odeme.amount.$touch();
            if (this.$v.paymnet_channel.$invalid ||  this.$v.odeme.amount.$invalid) return;

            Vue.swal({
                title: "Üyelik yenilensin mi?",
                showCancelButton: true,
                cancelButtonText: "İptal",
                confirmButtonText: "Yenile"
            }).then((result) => {
                if (result.value) {
                    
                    const { id,new_tariff_id,_installment } = this.form

                    if(this.paymnet_type == 6){
                        this.$http.post('/members/' + id + '/odemeLinki', { amount:  this.odeme.amount, type: 'yenile' })
                        .then(response => {
                            this.loading = false
                            if(response.data.code == 100){
                                 this.$swal({
                                    title: "Başarılı",
                                    html: `
                                        <p id="swal-text"> ${response.data.content}</p>
                                        <button id="copy-button" class="swal2-confirm swal2-styled" style="margin-top: 10px;">Kopyala</button> `,
                                    icon: "warning",
                                    showConfirmButton: false,
                                    didOpen: () => {
                                        const copyButton = document.getElementById('copy-button');
                                        copyButton.addEventListener('click', this.copyText);
                                    }
                                });
                                return 
                            }
                            return notify.error(response.data.message)
                        })

                        return
                    }
                     
               

                    this.loading = true;

                    let postData = { 
                        new_tariff_id, 
                        odeme:{ ...this.odeme,paymnet_type:this.paymnet_type }
                    };
                    if(_installment){
                        let odenen_taksitler = this.odenen_taksitler;

                        odenen_taksitler.sort((a, b) => a - b);
                        postData = {
                            ...postData,
                            _installment, 
                            odenen_taksitler 
                        }
                    }
                   
                    this.$http.post(`/members/${id}/renewal`, postData)
                        .then((e) => {
                            this.loading = false;
                            if (e && e.status == 200) {

                                if (e.data.error) {
                                    notify.error(e.data.message)
                                    return false
                                }

                                this.submitted = false;
                                this.odeme= { price: 0,  amount:"" }
                                this.payAfterInfo = { expiredate : e.data.content.expiredate, balance : e.data.content.balance }
                                this.paymnet_channel = ""
                                this.form = { new_tariff_id: null }
                                this.$v.paymnet_channel.$reset();
                                this.$v.odeme.amount.$reset();

                                this.printModelOpen = Math.floor(Math.random() * 1000);
                                this.checkId = e.data.content.ids
                                this.subsId = id
                                this.$parent.$bvModal.show('print_modal')
                              
                            }else{
                                notify.error("Bir hata oluştu ve bildirildi.")
                            }
                            //this.close()
                        })
                }
            });
        },
        copyText() {
            const text = document.getElementById('swal-text').innerText;
            navigator.clipboard.writeText(text).then(() => {
               this.$swal('Kopyalandı!', 'Metin başarıyla kopyalandı.', 'success');
            }).catch(() => {
                this.$swal('Hata!', 'Metin kopyalanamadı.', 'error');
            });
        },
        getBanks(paymnet_type){
            let type= 0;

            if( paymnet_type == 2)
            type = 'banka'
            else if( paymnet_type == 3)
            type = 'cek'
            else if( paymnet_type == 4)
            type = 'havale'

            this.$http.post(`safebank`,{ output:'only', type} )
                        .then((resp) => {
                            this.banks = resp.data
                        })
        },

        createPayment( { target }){ 
            this.odemeyap = true
            this.paymnet_type = target.value
            this.getBanks(target.value)
        },  

        pickTariff(){
            if(!this.form.new_tariff_id){
               this.odeme.price = this.form.price
               return 
            }  
            
            const filteredData = this.tariffList.find(e=>{
                this.installments=  e.installments
                this.installment_price=  e.installment_price
                return e.id === this.form.new_tariff_id
            });
            this.odeme.price = filteredData.price
        },

        gunFark() {
            const hedefTarih = this.form.expiredate
            var suAnkiTarih = new Date();
            var hedefTarihObj = new Date(hedefTarih);
            var gunFarki = Math.floor((  hedefTarihObj - suAnkiTarih ) / (1000 * 60 * 60 * 24));
            return gunFarki < 5;
        },

        tahsilet(){
            this.$http.post(`/members/${this.form.id}/tahsilat`)
            .then(r=>{
                if(!r.data.error){
                    notify.success('Tahsil edildi.')
                    this.form = { ...this.form, balance: 0 }
                }
                
            })
        },
        getRandomInt() {
            return Math.floor(Math.random() * 1000);
        },
        kontrol(i){
            if(i == 1){
                return false
            }
            if(this.secili.length+1 >= i ){
                return false
            }

            return true
        }
    },
};
</script>

<template>
<b-modal id="renewal_modal"  size="lg" :title="modalTitle"  no-close-on-backdrop hide-footer>
    <CreatePaymentModal 
        :data="paymentModelOpen"
    />

     <PayLink 
      :modelOpen="paylinkModalOpen"
      :data="paylinkData" 
    />

     <PrintMainVue 
      :data="checkId"
      :subsId="subsId"
      reference="yenile"
      :modalopen="printModelOpen"
    />

    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md-8">
                <div class="alert alert-warning">
                    {{ form.fname }}
                    {{ form.lname }}
                    <br>
                    {{ form.username}}
                </div>
            </div>
            <div class="col-md-4">
                <div class="card mini-stats-wid shadow-lg p-2 mb-5 bg-body rounded">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium mb-2">Bakiyesi</p>
                            <h4 class="mb-0">{{ form.balance }}</h4>
                        </div>
                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                            <span class="avatar-title"><i class="bx bx-wallet font-size-24"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <!-- BAKİYESİ VARSA VE BAYİ İSE GÖSTER-->
        <div class="row" v-if="!isAdmin && form.balance < 0">
            <div class="col-md-12">
                <div class="alert alert-danger">
                MÜŞTERİNİN MERKEZE BAKİYESİ BULUNMAKTADIR</div>
            </div>
        </div>
        <div v-if="isAdmin || form.balance >= 0">
            <div class="row d-flex flex-wrap mb-1">
                <label class="col-sm-4 col-form-label col-form-label">Mevcut Tarife</label>
                <div class="col col-form-label">
                    {{ form.tariff_name }}
                </div>
            </div>
            <div class="row d-flex flex-wrap mb-1" >
                <label class="col-sm-4 col-form-label col-form-label">Bitiş Tarihi</label>
                <div class="col col-form-label">
                    {{ form.expiredate_format }}
                </div>
            </div>
            <div class="row d-flex flex-wrap mb-1" >
                <label class="col-sm-4 col-form-label col-form-label"><span v-if="installment_price > 0">Peşin</span> Ödenecek Ücret</label>
                <div class="col col-form-label">
                    {{ odeme.price }} TL
                </div>
            </div>
             <div class="row d-flex flex-wrap mb-1"  v-if="installment_price > 0">
                <label class="col-sm-4 col-form-label col-form-label"><span>Taksitli</span> Ücret</label>
                <div class="col col-form-label">
                    {{ installment_price }}
                </div>
            </div>
            <div class="row d-flex flex-wrap mb-1" >
                <label class="col-sm-4 col-form-label col-form-label">Değiştirilecek Servis</label>
                <div class="col col-form-label" v-if="gunFark() || form.tariff_active == 0 ">
                    <v-select 
                        v-model="form.new_tariff_id"
                        @input="pickTariff()"
                        :options="tariffList"
                        :reduce="r => r.id"
                        label="name"
                        >
                    <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                    <span class="text-danger" v-if="form.tariff_active == 0">
                        Servisi artık uzatılmaz.Yeni servis üzerinden uzatınız.
                    </span>
                </div>
                <div class="col" v-else>
                    Tarife Değişimi Yapılamaz
                </div>
            </div>

        </div>

        <div class="row d-flex flex-wrap mb-1" v-if="installments && installments.length > 0">
            <label class="col-sm-4 col-form-label" for="flexSwitchCheckDefault">Taksitli Satış Yap</label>
            <div class="col col-form-label">
                <input 
                class="form-check-input" 
                type="checkbox" 
                v-model="form._installment"
                value="1"
                id="flexSwitchCheckDefault">
            </div>
        </div>
        <div class="row" v-if="form._installment && installments && installments.length > 0">
            <hr style="margin-top:10px"/>
            <div class="offset-md-4 col">
                <table class="table table-bordered table-hover table-sm">
                    <thead class="thead-light">
                        <tr>
                            <th colspan="3">Kaç Ödeme Alınacak</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment,i) in this.installments" :key="i">
                            <th style="width:10px">
                                <input 
                                    :id="`checkbox${i}`"
                                    type="checkbox" 
                                    v-model="secili" 
                                    :value="installment"
                                    :disabled="kontrol(installment.num)"
                                    > 
                            </th>
                            <th class="text-end ml-3">{{ installment.num }} . Taksit</th>
                            <th class="text-start ml-3" style="width:50%">{{ installment.price }} TL</th>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr style="background:#d7d7d7">
                            <th class="text-end ml-3" colspan=2>Toplam Ödenecek</th>
                            <th class="text-start ml-3">{{ installment_price }} TL</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <hr />
        <div v-if="isAdmin">
            <div class="row d-flex flex-wrap mb-1">
                <label class="col-sm-4 col-form-label col-form-label">Ödeme Türü</label>
                <div class="col col-form-label">
                    <select  
                        class="form-select" 
                        @change="createPayment($event)"
                        v-model="paymnet_channel"
                        :class="{'is-invalid': submitted && $v.paymnet_channel.$error}">
                            <option value="">Seçiniz</option>
                            <option value="5">Veresiye</option>
                            <option value="1">Nakit</option>
                            <option value="2">Kredi Kartı</option>
                            <option value="6">Ödeme Linki</option>
                            <option value="4">Havale</option>
                            <option value="3">Çek</option>
                    </select>
                    <div
                      v-if="submitted && $v.paymnet_channel.$error"
                      class="invalid-feedback"
                    >   Bu alanı doldurmak zorunludur.
                    </div>
                </div>
            </div>
            <div v-if="odemeyap">
                <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type != 5">
                    <label class="col-sm-4 col-form-label col-form-label" for="amount">Ödenen Ücret</label>
                    <div class="col col-form-label">
                        <input
                            id="amount" 
                            v-model="odeme.amount"
                            type="text"
                            class="form-control"
                            :class="{'is-invalid': submitted && $v.odeme.amount.$error}"
                        />
                        <div
                        v-if="submitted && $v.odeme.amount.$error"
                        class="invalid-feedback"
                        >   Bu alanı doldurmak zorunludur.
                        </div>
                    </div>
                </div>

                <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 2 || paymnet_type == 3 || paymnet_type == 4">
                    <label class="col-sm-4 col-form-label col-form-label" for="bank" >Banka</label>
                    <div class="col col-form-label">
                        <select class="form-select" v-model="odeme.credit_card_bank" id="bank">
                            <option :value="bank.id" v-for="bank in banks" :key="bank.id">{{ bank.title }} </option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
                    <label class="col-sm-4 col-form-label col-form-label" for="cheque_giver_name">Çek Sahibi</label>
                    <div class="col col-form-label">
                        <input
                        id="cheque_giver_name" 
                        v-model="odeme.cheque_giver_name"
                        type="text"
                        class="form-control"
                        />
                    </div>
                </div>

                <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type == 3">
                    <label class="col-sm-4 col-form-label col-form-label" for="cheque_number">Çek Numarası</label>
                    <div class="col col-form-label">
                        <input
                        id="cheque_number" 
                        v-model="odeme.cheque_number"
                        type="text"
                        class="form-control"
                        />
                    </div>
                </div>

                <div class="row d-flex flex-wrap mb-1"  v-if="paymnet_type == 3">
                    <label class="col-sm-4 col-form-label col-form-label" for="cheque_date">Çek Tarihi</label>
                    <div class="col col-form-label">
                        <input
                        id="cheque_date" 
                        v-model="odeme.cheque_date"
                        type="date"
                        class="form-control"
                        />
                    </div>
                </div>

                <div class="row d-flex flex-wrap mb-1" v-if="paymnet_type != 5">
                    <label class="col-sm-4 col-form-label col-form-label" for="invoice_num">Makbuz No</label>
                    <div class="col col-form-label">
                        <input
                        id="invoice_num" 
                        v-model="odeme.invoice_num"
                        type="text"
                        class="form-control"
                        />
                    </div>
                </div>

                <div class="row d-flex flex-wrap mb-1" >
                    <label class="col-sm-4 col-form-label col-form-label" for="explaine">Açıklama</label>
                    <div class="col col-form-label">
                            <input
                            id="explaine" 
                            v-model="odeme.explaine"
                            type="text"
                            class="form-control"
                            />
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                v-if="!isAdmin && form.balance < 0" 
                variant="primary" 
                @click="tahsilet()">
                Bakiyeyi Tahsil Et
            </b-button>
            <b-button 
                v-else
                type="submit" 
                variant="warning" 
                class="ms-1"
                :disabled="loading"
                >
                <span v-if="loading"> 
                    <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                </span>
                Yenile
            </b-button>
        </div>
    </form>
</b-modal>
</template>